import { Col, Create, Form, Input, Row, notification, useForm } from '@pankod/refine-antd';
import { useNavigation } from '@pankod/refine-core';
import { TypesFormList } from 'components';
import { useState } from 'react';
import { ITemplate, createTemplate } from 'services/template';
import { findDuplicate } from 'utilities/shared';

export const TemplateCreate: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { form, formProps, saveButtonProps, queryResult } = useForm<ITemplate>();
  const { push } = useNavigation();

  const onFinish = async (values: any) => {
    // Validation
    let attributes = form.getFieldValue('attributes') as any[];
    attributes = attributes.map((attribute) => {
      const { name, type, required, allowCustomValue, options } = attribute;

      if (attribute.type === 'Dropdown') {
        return { name, type, required, allowCustomValue, options };
      }
      if (attribute.type === 'Boolean') {
        return { name, type, required, options: [], allowCustomValue: false };
      }
      return { name, type, required, options: [], allowCustomValue: true };
    });

    const duplicates = findDuplicate(attributes, 'name');
    if (duplicates.length) {
      form.setFields([
        {
          name: 'attributes',
          errors: [`'${duplicates.join(', ')}' duplicate names found!`],
        },
      ]);
      return;
    }

    // API call
    try {
      setIsLoading(true);
      await createTemplate({ ...values, attributes });
      notification.success({
        message: 'Success',
        description: 'Template created successfully',
      });
      push('/products/templates');
    } catch (err: any) {
      console.error(err.message);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={{ ...saveButtonProps, disabled: isLoading }}
    >
      <Form
        {...formProps}
        form={form}
        layout="vertical"
        initialValues={{
          isActive: true,
        }}
        onFinish={onFinish}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Description" name="description">
              <Input.TextArea rows={3} />
            </Form.Item>

            <TypesFormList name="attributes" />
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
